<template>
    <div v-if="activity != null" class="activity-info">
        <ul>
            <li v-if="educationLevels">
                <i
                    class="mr-1 color--white"
                    :class="'fa-icon__' + getTargetAudience()"
                    aria-hidden="true"
                ></i
                >{{ educationLevels }}
            </li>
            <li v-if="activity.costType > 0 || activity.costs">
                <i class="fas fa-euro-sign mr-1"></i>
                <span
                    v-if="
                        activity.costType == 1 ||
                            activity.costType == 2 ||
                            activity.costType == 3
                    "
                >
                    <span v-if="activity.costType == 1"
                        >{{ activity.costs }} per groep</span
                    >
                    <span v-if="activity.costType == 2"
                        >{{ activity.costs }} per kind</span
                    >
                    <span v-if="activity.costType == 3">Gratis</span>
                </span>
                <span v-else>{{ activity.costs }}</span>
            </li>
            <li v-if="!showDates" class="multi-line">
                <i class="fas fa-calendar mr-1"></i
                ><span class="d-inline-block"
                    >Er zijn op dit moment geen nieuwe datums ingepland</span
                >
            </li>
            <li v-if="dates && showDates" class="multi-line">
                <i class="fas fa-calendar mr-1"></i
                ><span class="d-inline-block" v-html="dates"></span>
            </li>
            <li
                v-if="times != null && times != '' && showDates"
                class="multi-line"
            >
                <i class="fas fa-clock mr-1"></i>
                <span class="d-inline-block" v-html="times"></span>
            </li>
            <li
                v-else-if="
                    activity.duration != null && activity.duration[0] != null
                "
                class="multi-line"
            >
                <i class="fas fa-clock mr-1"></i>
                <span class="d-inline-block">
                    {{ activity.duration[0].name }}
                </span>
            </li>
            <li v-if="activity.remark" class="multi-line">
                <i class="fas fa-check mr-1"></i
                ><span class="d-inline-block">{{ activity.remark }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        },
        showDates: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            educationLevels: '',
            dates: '',
            times: ''
        };
    },
    watch: {
        activity: {
            immediate: true,
            deep: true,
            handler() {
                if (this.activity.educationLevel != null) {
                    this.educationLevels =
                        'Groep ' +
                        this.activity.educationLevel
                            .map(function(el) {
                                return el.name.replace('Groep', '');
                            })
                            .join(' / ');
                }

                const options = {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit'
                };

                let beginDate = new Date(this.activity.beginDate);
                let endDate = new Date(this.activity.endDate);

                beginDate = beginDate.toLocaleDateString('nl-NL', options);
                endDate = endDate.toLocaleDateString('nl-NL', options);

                let occurenceDays = [];

                if (this.activity.occurenceDays != null) {
                    occurenceDays = this.activity.occurenceDays.map(function(
                        el
                    ) {
                        return el.name;
                    });

                    if (this.activity.occurenceDays.length == 2) {
                        occurenceDays = occurenceDays.join(' & ');
                    } else {
                        occurenceDays = occurenceDays.join(', ');
                    }

                    if (this.activity.occurenceDays.length > 1) {
                        occurenceDays = ' ' + occurenceDays;
                    }
                }

                let occurenceInterval = [];
                let onlyOccursOnce = false;
                if (this.activity.occurenceInterval != null) {
                    occurenceInterval = this.activity.occurenceInterval.map(
                        function(el) {
                            return el.name;
                        }
                    );

                    if (occurenceInterval[0].toLowerCase() == 'eenmalig') {
                        onlyOccursOnce = true;
                        occurenceDays = beginDate;
                    }
                    occurenceDays = (
                        occurenceInterval +
                        ' op ' +
                        occurenceDays +
                        '.'
                    ).trim();
                }

                if (
                    (this.activity.beginDate == null ||
                        this.activity.beginDate == '') &&
                    (this.activity.endDate == null ||
                        this.activity.endDate == '')
                ) {
                    this.dates = '';
                } else if (
                    this.activity.beginDate == this.activity.endDate ||
                    this.activity.endDate == null
                ) {
                    this.dates = beginDate;
                } else {
                    this.dates = onlyOccursOnce
                        ? occurenceDays
                        : (
                              occurenceDays +
                              ' ' +
                              '</br>' +
                              'Van ' +
                              beginDate +
                              ' tot ' +
                              endDate
                          ).trim();
                }

                this.times = [];

                if (
                    this.activity.times != null &&
                    this.activity.times != undefined
                ) {
                    const object = JSON.parse(this.activity.times);
                    for (let i = 0; i < object.length; i++) {
                        const time = object[i];
                        if (time.endTime == null || time.endTime == '') {
                            this.times.push(time.startTime.toString());
                        } else {
                            this.times.push(
                                (
                                    time.startTime.slice(0, 2) +
                                    ':' +
                                    time.startTime.slice(2, 4) +
                                    ' - ' +
                                    time.endTime.slice(0, 2) +
                                    ':' +
                                    time.endTime.slice(2, 4)
                                ).toString()
                            );
                        }
                    }
                }

                this.times = this.times.join('<br />');
            }
        }
    },
    methods: {
        getTargetAudience() {
            return this.activity.targetAudience != null &&
                this.activity.targetAudience[0] != null
                ? this.activity.targetAudience[0].className
                : '';
        }
    }
};
</script>

<style lang="scss">
.activity-info {
    background-color: $blue-7;
    color: $white;
    font-size: 1.125rem;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    padding: 38px 25px 30px 25px;
    position: relative;
    width: 100%;
}

.activity-info ul {
    list-style: none;
    padding: 0;
}

.activity-info li {
    margin-bottom: 10px;
    font-weight: bold;
}

.activity-info i {
    width: 25px;
}
.activity-info {
    .multi-line {
        position: relative;
        i {
            position: absolute;
            top: 10px;
            left: 0;
        }
        span {
            padding-left: 35px;
        }
    }
}
</style>
